import { Component, TemplateRef, contentChild, inject, input } from "@angular/core";
import { MergePatientsSelectionService } from "./services/merge-patients-selection.service";
import { ConfirmationService } from "primeng/api";
import { CommonModule } from "@angular/common";
import { FieldsetModule } from "primeng/fieldset";
import { ButtonModule } from "primeng/button";
import { CustomConfirmDialogKey, CustomDialogConfirmation } from "@bbwt/components/root-confirm-dialog";
import { MergePatientAction } from "./services/merge-patients-action";
import { TooltipModule } from "primeng/tooltip";

@Component({
    selector: "merge-patients-selection",
    standalone: true,
    imports: [CommonModule, FieldsetModule, ButtonModule, TooltipModule],
    templateUrl: "./merge-patients-selection.component.html"
})
export class MergePatientsSelectionComponent {
    clearSelection = input(true);
    swapSelection = input(true);
    disabled = input(false);

    private readonly confirmationService = inject(ConfirmationService);
    private readonly mergeAction = inject(MergePatientAction);
    protected readonly selectionService = inject(MergePatientsSelectionService);
    protected readonly emptyMessage = contentChild<TemplateRef<unknown>>("emptyMessage");
    protected readonly selectChildMessage = contentChild<TemplateRef<unknown>>("selectChildMessage");

    protected mergePatients() {
        const parent = this.selectionService.parentPatient();
        const child = this.selectionService.childPatient();

        this.confirmationService.confirm({
            header: "Merge Patients",
            key: CustomConfirmDialogKey,
            styleClass: "w-11 sm:w-9 md:w-5",
            message: `
                <p>
                    <span class="text-danger font-bold">Merging</span> two Patients is permanent, and cannot be undone in the future.
                </p>
                <p>
                    <b>Note</b>: After the merge, Patient <b>${child.firstName} ${child.lastName}</b> with ORB Number
                    <b>${child.miProNumber}</b> will be deleted and all its data moved to Patient
                    <b>${parent.firstName} ${parent.lastName}</b> with ORB Number <b>${parent.miProNumber}</b>.
                </p>
                <p>
                    Would you like to proceed with the Merge?
                </p>
            `,
            accept: () => this.mergeAction?.merge(parent, child)
        } as CustomDialogConfirmation);
    }
}
